import { Component, OnInit } from '@angular/core';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { OrgEmployeePositionActionsComponent } from 'src/app/components/dialog/organization/org-employee-position-actions/org-employee-position-actions.component';
import { PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { PositionsList } from 'src/app/models/positions.model';
import { LanguageService, DialogModalService, NotificationService } from 'src/app/services';
import { ApiOrgPositionsService } from 'src/app/services/api-org-positions.service';

@Component({
  selector: 'app-employee-positions',
  templateUrl: './employee-positions.component.html',
  styleUrls: ['./employee-positions.component.css']
})
export class EmployeePositionsComponent implements OnInit {
  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  positions: PositionsList[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiOrgPositions: ApiOrgPositionsService,
    private dialogModal: DialogModalService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.positions = [];

    this.setListParams();

    this.apiOrgPositions.getList(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] GET LIST POSITIONS: ', response);

      if (response != null && response.result != null) {

        this.positions = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }


  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        org_id: ''
      },
      object: 'orgs_users',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
  * 
  * @param ids 
  */
    onConfirm(ids: string[]) {

      let message = 'Вы действительно хотите удалить?';
  
      this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
        (result) => {
  
          if (result) {
  
            this.onDelete(ids);
          }
        },
        () => { console.log('Rejected!'); }
      );
  
    }


  /**
   * 
   * @param ids 
   */
  onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrgPositions.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
  * 
  */
  onCreate() {

    this.dialogModal.open('', OrgEmployeePositionActionsComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   * @param i 
   */
  onEdit(i: number) {

    let data = {
      position_id: this.positions[i].id
    }

    this.dialogModal.open(data, OrgEmployeePositionActionsComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }


}
